module.exports = __webpack_public_path__ + "static/img/banner_recruit_02.29606be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/resource/images/join/banner_recruit_02.png
// module id = PrlM
// module chunks = 10